import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { CareTeamBlock, FieldsBlock, JourneysBlock, NotesBlock, TagsBlock } from "./information";
import { RelatedContactsBlock } from "./related-contacts";
import { BlockProps } from "../../types";
import { AISummaryBlock, TimelineBlock } from "./timeline";
import { TicketsBlock } from "./tickets";
import { CalendarBlock } from "./calendar";
import { EligibilityBlock } from "./eligibility";
import { OrdersBlock } from "./orders";
import { FilesBlock } from "./files";
import { FormsBlock } from "./forms";
import { ContentBlock } from "./content";
import { MedicationsBlock } from "./medications";
import { PaymentsBlock } from "./payments";
import { VitalsBlock } from "./vitals";

export interface ContactDetailsBlockSwitchProps extends Omit<BlockProps, "info" | "canUpdateObservations"> {
  block: TellescopeModelFromName<"custom_dashboards">["blocks"][number];
  /** Required here because any block type may be selected at runtime, including vitals. */
  canUpdateObservations: boolean;
}

export const ContactDetailsBlockSwitch = ({ block, ...props }: ContactDetailsBlockSwitchProps) => {
  const blockProps = { ...props, info: block.info };

  switch (block.type) {
    case "information.tags":
      return <TagsBlock {...blockProps} />;
    case "information.notes":
      return <NotesBlock {...blockProps} />;
    case "information.fields":
      return <FieldsBlock {...blockProps} />;
    case "information.care-team":
      return <CareTeamBlock {...blockProps} />;
    case "information.journeys":
      return <JourneysBlock {...blockProps} />;
    case "related-contacts.related-contacts":
      return <RelatedContactsBlock {...blockProps} />;
    case "timeline.ai-summary":
      return <AISummaryBlock {...blockProps} />;
    case "timeline.timeline":
      return <TimelineBlock {...blockProps} />;
    case "tickets.tickets":
      return <TicketsBlock {...blockProps} />;
    case "calendar.calendar":
      return <CalendarBlock {...blockProps} />;
    case "eligibility.eligibility":
      return <EligibilityBlock {...blockProps} />;
    case "orders.orders":
      return <OrdersBlock {...blockProps} />;
    case "files.files":
      return <FilesBlock {...blockProps} />;
    case "forms.forms":
      return <FormsBlock {...blockProps} />;
    case "content.content":
      return <ContentBlock {...blockProps} />;
    case "medications.medications":
      return <MedicationsBlock {...blockProps} />;
    case "payments.payments":
      return <PaymentsBlock {...blockProps} />;
    case "vitals.vitals":
      return <VitalsBlock {...blockProps} />;
  }

  return null;
};
